import { ClientDashboardAppConfig } from "./client-dashboard/ClientDashboardAppConfig";

export const ClientAppsConfigs = [ClientDashboardAppConfig];
